export default __webpack_public_path__ + "static/media/modal-waves-image-2.6dc20261.jpg";